<template>
    <ies-form-field :field="field">
        <v-row>
            <v-col cols="12">
                <v-card outlined class="trip-itinerary-item mb-4 pa-4" v-for="(item, index) in itineraryItems" :key="index">
                    <v-row dense align="center">
                        <v-col cols="12" sm="2">
                            <v-text-field label="Day Range" hide-details outlined dense v-model="itineraryItems[index].day_range"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field label="Subtitle" hide-details outlined dense v-model="itineraryItems[index].subtitle"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="1">
                            <v-btn icon small v-on:click="toggleExpanded(index)" :title="expandedItems[index] ? 'Collapse' : 'Expand'">
                                <v-icon>{{ expandedItems[index] ? 'expand_less' : 'expand_more' }}</v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" sm="3" class="text-right">
                            <v-btn icon small title="Move up" v-on:click="moveUp(index)" :disabled="index === 0"><v-icon>arrow_upward</v-icon></v-btn>
                            <v-btn icon small title="Move down" v-on:click="moveDown(index)" :disabled="index === itineraryItems.length - 1"><v-icon>arrow_downward</v-icon></v-btn>
                            <v-btn icon small title="Delete" class="ies-coral--text" v-on:click="deleteItem(index)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-expand-transition>
                        <div v-show="expandedItems[index]" class="mt-3">
                            <v-row dense class="mb-3">
                                <v-col cols="12" sm="4">
                                    <v-autocomplete
                                        label="Location"
                                        hide-details
                                        outlined
                                        dense
                                        clearable
                                        :items="locations"
                                        item-text="name"
                                        item-value="location_key"
                                        v-model="itineraryItems[index].location_key"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-autocomplete
                                        label="Hotel"
                                        hide-details
                                        outlined
                                        dense
                                        clearable
                                        :items="hotels"
                                        item-text="display"
                                        item-value="hotel_key"
                                        v-model="itineraryItems[index].hotel_key"
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field label="Transport & Duration" hide-details outlined dense v-model="itineraryItems[index].transport"></v-text-field>
                                </v-col>

                            </v-row>
                            <v-row dense>
                                <v-col cols="12">
                                    <tinymce
                                        :id="'tinymce_trip_itinerary_item_' + index"
                                        :init="tinymceConfiguration.init"
                                        v-model="itineraryItems[index].description"
                                    ></tinymce>
                                </v-col>
                            </v-row>
                            <v-row dense class="mb-3">
                                <v-col cols="12">
                                    <ies-image :field="imageFields[index]"></ies-image>
                                </v-col>
                            </v-row>
                        </div>
                    </v-expand-transition>
                </v-card>
            </v-col>
            <v-col cols="12" sm="3" offset-sm="9" class="text-right">
                <v-btn class="ies-green" title="Add Item" v-on:click="addItem()"><v-icon>add</v-icon></v-btn>
            </v-col>
            <input type="hidden" :name="this.field.fieldName" :value="field.value">
        </v-row>
    </ies-form-field>
</template>

<style>
.trip-itinerary-item .v-textarea textarea {
    border: none;
    height: auto;
    margin-bottom: 0;
    padding: 0;
}
</style>

<script>
    import Editor from '@tinymce/tinymce-vue';

    export default {
        name: 'ies-input-trip-itinerary-items',
        props: ['field', 'recordData', 'page'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
            'ies-image': require('./Image.vue').default,
            'tinymce': Editor,
        },
        data() {
            return {
                tripKey: 0,
                itineraryItems: [],
                expandedItems: [],
                imageFields: [],
                hotels: [],
                locations: [],
                tinymceConfiguration: {
                    init: {
                        license_key: 'gpl',
                        remove_linebreaks: false,
                        plugins: 'advlist autolink lists link image charmap anchor searchreplace visualblocks code insertdatetime media contextmenu paste code',
                        toolbar: 'undo redo | insert | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
                    },
                },
            }
        },

        created: function() {
            this.tripKey = this.getTripKeyFromUrl();
            if (this.tripKey > 0) {
                this.getItineraryItems();
            }
            this.getHotels();
            this.getLocations();
            this.syncFieldValue();
        },

        methods: {
            getTripKeyFromUrl: function() {
                if (!this.page || !this.page.edit_url) {
                    return 0;
                }
                var bits = this.page.edit_url.split('/');
                var foundIndex = null;
                bits.forEach(function(bit, index) {
                    if (bit == '{Trip.trip_key}') {
                        foundIndex = index;
                    }
                });
                if (foundIndex === null) {
                    return 0;
                }
                var urlBits = location.pathname.split('/').splice(1);
                return parseInt(urlBits[foundIndex]) || 0;
            },

            getHotels: function() {
                axios.get('/api/selectable-hotels').then((response) => {
                    this.hotels = response.data.hotels.map(function(hotel) {
                        return {
                            hotel_key: hotel.hotel_key,
                            display:   '(' + hotel.hotel_code + ') ' + hotel.hotel_name + (!hotel.display ? ' (offline)' : '') + (hotel.bookable_via_iescape ? "" : " (not bookable)"),
                        };
                    });
                });
            },

            getLocations: function() {
                axios.get('/api/selectable-locations').then((response) => {
                    this.locations = response.data.locations;
                });
            },

            getItineraryItems: function() {
                axios.get('/api/trip-itinerary-items/' + this.tripKey).then((response) => {
                    if (response.data.itineraryItems && response.data.itineraryItems.length) {
                        this.itineraryItems = response.data.itineraryItems.map(function(item) {
                            return {
                                day_range:   item.day_range,
                                location_key: item.location_key,
                                subtitle:    item.subtitle,
                                description: item.description,
                                transport:   item.transport,
                                hotel_key:   item.hotel_key,
                                main_image_key: item.main_image_key,
                                sort_order:  item.sort_order,
                            };
                        });
                        this.expandedItems = this.itineraryItems.map(function() {
                            return false;
                        });
                        this.imageFields = this.itineraryItems.map(function(item, itemIndex) {
                            return {
                                value:     item.main_image_key,
                                fieldName: 'trip-itinerary-item-' + itemIndex + '-image',
                            };
                        });
                        this.syncFieldValue();
                    }
                });
            },

            addItem: function() {
                this.itineraryItems.push({
                    day_range:   '',
                    location_key: null,
                    subtitle:    '',
                    description: '',
                    transport:   '',
                    hotel_key:   null,
                    main_image_key: null,
                    sort_order:  this.itineraryItems.length,
                });
                this.expandedItems.push(true);
                this.imageFields.push({
                    value:     null,
                    fieldName: 'trip-itinerary-item-' + (this.itineraryItems.length - 1) + '-image',
                });
            },

            deleteItem: function(index) {
                this.itineraryItems.splice(index, 1);
                this.expandedItems.splice(index, 1);
                this.imageFields.splice(index, 1);
            },

            moveUp: function(index) {
                if (index === 0) {
                    return;
                }
                var moved = this.itineraryItems.splice(index, 1)[0];
                this.itineraryItems.splice(index - 1, 0, moved);
                var movedExpanded = this.expandedItems.splice(index, 1)[0];
                this.expandedItems.splice(index - 1, 0, movedExpanded);
                var movedImageField = this.imageFields.splice(index, 1)[0];
                this.imageFields.splice(index - 1, 0, movedImageField);
            },

            moveDown: function(index) {
                if (index === this.itineraryItems.length - 1) {
                    return;
                }
                var moved = this.itineraryItems.splice(index, 1)[0];
                this.itineraryItems.splice(index + 1, 0, moved);
                var movedExpanded = this.expandedItems.splice(index, 1)[0];
                this.expandedItems.splice(index + 1, 0, movedExpanded);
                var movedImageField = this.imageFields.splice(index, 1)[0];
                this.imageFields.splice(index + 1, 0, movedImageField);
            },

            toggleExpanded: function(index) {
                this.$set(this.expandedItems, index, !this.expandedItems[index]);
            },

            syncFieldValue: function() {
                this.field.value = {
                    trip_key:       this.tripKey,
                    itineraryItems: this.itineraryItems,
                };
            },
        },

        watch: {
            itineraryItems: {
                handler: function() {
                    this.syncFieldValue();
                },
                deep: true,
            },
            imageFields: {
                handler: function() {
                    var self = this;
                    this.imageFields.forEach(function(imageField, index) {
                        if (self.itineraryItems[index] && self.itineraryItems[index].main_image_key !== imageField.value) {
                            self.itineraryItems[index].main_image_key = imageField.value;
                        }
                    });
                },
                deep: true,
            },
        },
    }
</script>
